const dateOptions = { day: 'numeric', month: 'short',  year: '2-digit' };

export const dateLocal = (d) => new Date(d).toLocaleDateString('tr-TR', dateOptions);

